import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { BroadcastTags_queryKey } from './constants';
import { BroadcastTag } from '../../../models/broadcastTag.model';
import { createBroadcastTag } from '../../../api/appSettings.service';

export const useCreateBroadcastTagQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate, data } = useMutation({
    mutationFn: async (broadcastTag: Pick<BroadcastTag, 'name' | 'order'>) => {
      setLoading();

      return createBroadcastTag(broadcastTag);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BroadcastTags_queryKey] });
      toast.success('Broadcast Tags created successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => removeLoading(),
  });

  return { isLoading: isPending, mutate, data };
};
